export interface MockDemo {
  a: Function;
}
// 产品要求先写死这5个
export const ShopTypeEnum = [
  { value: 1, label: '商场店' },
  { value: 2, label: '街铺店' },
  { value: 3, label: '景区店' },
  { value: 4, label: '交通枢纽店' },
  { value: 5, label: '社区店' },
];

export const RendTypeEnum = [
  { value: 1, label: '固定租金' },
  { value: 2, label: '扣点' },
  { value: 3, label: '取高' },
  { value: 4, label: '其他' },
];

export const PayTypeEnum = [
  { value: 1, label: '月付' },
  { value: 2, label: '季付' },
  { value: 3, label: '半年付' },
  { value: 4, label: '年付' },
  { value: 5, label: '其他' },
];

/** 开店状态枚举 */
export enum ShopStatus {
  /** 已签约 */
  SIGNED = 100,
  /** 交房审批中 */
  DELIVERY_APPROVING = 200,
  /** 已交房 */
  DELIVERED = 300,
  /** 开业审批中 */
  OPEN_APPROVING = 400,
  /** 开业中 */
  OPENING = 500,
  /** 闭店审批中 */
  CLOSE_APPROVING = 600,
  /** 已闭店 */
  CLOSED = 700,
  /** 已迁址 */
  RELOCATED = 800,
  /** 已解约 */
  TERMINATION_CONTRACT = 900,
}


